import { c as _c } from "react/compiler-runtime";
import { Box, type SxProps, type Theme } from '@mui/material';
export const BrowserGrid = t0 => {
  const $ = _c(7);
  const {
    children,
    gap: t1,
    columns: t2,
    sx
  } = t0;
  const gap = t1 === undefined ? "24px" : t1;
  const columns = t2 === undefined ? 2 : t2;
  const t3 = `repeat(${columns}, 1fr)`;
  let t4;
  if ($[0] !== gap || $[1] !== sx || $[2] !== t3) {
    t4 = {
      display: "grid",
      gridTemplateColumns: t3,
      gap,
      ...sx
    };
    $[0] = gap;
    $[1] = sx;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== children || $[5] !== t4) {
    t5 = <Box sx={t4}>{children}</Box>;
    $[4] = children;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
};